import React from "react";
import Image from "next/image";

const TeamSectionDesktop = () => {
  return (
    // Desktop Version
    <>
      <div className="md:flex md:flex-col md:items-center md:justify-center hidden w-full px-4 md:px-5 xl:px-8 2xl:px-10 square_grid_bg bg-repeat bg-[length:100% 100%] md:pb-14">
        <div className="text-center mb-8">
          <h2 className="text-[#000] text-center font-[Work Sans] text-[36px] font-semibold leading-[normal] tracking-[-1.44px] inline-block mx-auto px-[4px] mb-3 pt-10">
            <span className="md:pb-0 inline-block border-[#ca7216] border-b-[4px]">
              Meet The Founding Team
            </span>
          </h2>
        </div>
        <div className="lg:container mx-auto xl:px-6 lg:p-0 z-20 relative left-[3%]">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 justify-center">
            <div className="relative bg-white w-full max-w-[180px] lg:max-w-[210px] h-[293px] rounded-[20px] shadow-md overflow-hidden">
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/about-us/Varun%20Jain.webp"
                alt="Varun Jain"
                className="object-cover w-full h-full rounded-[24px]"
                width={210}
                height={293}
              />
              <a
                href="https://www.linkedin.com/in/varunjain-cpa-cma-harvard-alumni/"
                target="_blank"
                rel="noopener noreferrer"
                className="absolute top-3 right-3 z-20"
              >
                <Image
                  src="/about-us/link.png"
                  alt="LinkedIn"
                  width={32}
                  height={32}
                  className="w-[30px] h-[30px]"
                />
              </a>
              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60 rounded-[16px]"></div>
              <div className="absolute bottom-4 left-4 text-white z-10">
                <h3 className="text-[16px] font-semibold">Varun Jain</h3>
                <p className="text-[14px] font-normal">Founder & CEO</p>
              </div>
            </div>

            <div className="relative bg-white lg:w-[210px] md:w-[180px] h-[293px] rounded-[20px] shadow-md overflow-hidden">
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/about-us/Meenakshi%20Jain.webp"
                alt="Meenakshi Jain"
                className="object-cover w-full h-full rounded-[24px]"
                width={210}
                height={293}
              />
              <a
                href="https://www.linkedin.com/in/meenakshi-jain-b60b248/"
                target="_blank"
                rel="noopener noreferrer"
                className="absolute top-3 right-3 z-20"
              >
                <Image
                  src="/about-us/link.png"
                  alt="LinkedIn"
                  width={30}
                  height={30}
                />
              </a>
              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60 rounded-[16px]"></div>
              <div className="absolute bottom-4 left-4 text-white z-10">
                <h3 className="text-[16px] font-semibold">Meenakshi Jain</h3>
                <p className="text-[14px] font-normal">Co-founder & COO</p>
              </div>
            </div>

            <div className="relative bg-white lg:w-[210px] md:w-[180px] h-[293px] rounded-[20px] shadow-md overflow-hidden">
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/about-us/Harsh%20Jain.webp"
                alt="Harsh Jain"
                className="object-cover w-full h-full rounded-[24px]"
                width={210}
                height={293}
              />
              <a
                href="https://www.linkedin.com/in/harsh-jain-874a281b9/"
                target="_blank"
                rel="noopener noreferrer"
                className="absolute top-3 right-3 z-20"
              >
                <Image
                  src="/about-us/link.png"
                  alt="LinkedIn"
                  width={30}
                  height={30}
                />
              </a>
              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60 rounded-[16px]"></div>
              <div className="absolute bottom-4 left-4 text-white z-10">
                <h3 className="text-[16px] font-semibold">Harsh Jain</h3>
                <p className="text-[14px] font-normal">
                  Co-founder & Executive Director
                </p>
              </div>
            </div>

            <div className="relative bg-white lg:w-[210px] md:w-[180px] h-[293px] rounded-[20px] shadow-md overflow-hidden">
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/about-us/Shivam%20Chopra.webp"
                alt="Shivam Chopra"
                className="object-cover w-full h-full rounded-[24px]"
                width={210}
                height={293}
              />
              <a
                href="https://www.linkedin.com/in/shivamchopra7/"
                target="_blank"
                rel="noopener noreferrer"
                className="absolute top-3 right-3 z-20"
              >
                <Image
                  src="/about-us/link.png"
                  alt="LinkedIn"
                  width={30}
                  height={30}
                />
              </a>
              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60 rounded-[16px]"></div>
              <div className="absolute bottom-4 left-4 text-white z-10">
                <h3 className="text-[16px] font-semibold">Shivam Chopra</h3>
                <p className="text-[14px] font-normal">Co-founder & CTO</p>
              </div>
            </div>

            <div className="relative bg-white lg:w-[210px] md:w-[180px] h-[293px] rounded-[20px] shadow-md overflow-hidden">
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/about-us/Ashish%20Jalan.webp"
                alt="Ashish Jalan
"
                className="object-cover w-full h-full rounded-[24px]"
                width={210}
                height={293}
              />
              <a
                href="https://www.linkedin.com/in/ajadvisory/"
                target="_blank"
                rel="noopener noreferrer"
                className="absolute top-3 right-3 z-20"
              >
                <Image
                  src="/about-us/link.png"
                  alt="LinkedIn"
                  width={30}
                  height={30}
                />
              </a>
              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60 rounded-[16px]"></div>
              <div className="absolute bottom-4 left-4 text-white z-10">
                <h3 className="text-[16px] font-semibold">Ashish Jalan</h3>
                <p className="text-[14px] font-normal">COO, Miles Talent Hub</p>
              </div>
            </div>

            <div className="relative bg-white lg:w-[210px] md:w-[180px] h-[293px] rounded-[20px] shadow-md overflow-hidden">
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/about-us/Pratish%20Nair.webp"
                alt="Pratish Nair"
                className="object-cover w-full h-full rounded-[24px]"
                width={210}
                height={293}
              />
              <a
                href="https://www.linkedin.com/in/pratish-r-nair-45b51416/"
                target="_blank"
                rel="noopener noreferrer"
                className="absolute top-3 right-3 z-20"
              >
                <Image
                  src="/about-us/link.png"
                  alt="LinkedIn"
                  width={30}
                  height={30}
                />
              </a>
              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60 rounded-[16px]"></div>
              <div className="absolute bottom-4 left-4 text-white z-10">
                <h3 className="text-[16px] font-semibold">Pratish Nair</h3>
                <p className="text-[14px] font-normal">
                  Founder & CEO, Miles SoBA
                </p>
              </div>
            </div>

            {/* <div className="relative bg-white lg:w-[210px] md:w-[180px] h-[293px] rounded-[20px] shadow-md overflow-hidden">
              <Image
                src="/about-us/Priya.webp"
                alt="Priya Nair"
                className="object-cover w-full h-full rounded-[24px]"
                width={210}
                height={293}
              />
              <a
                href="https://www.linkedin.com/in/priya-menon-nair-5b7a84111/"
                target="_blank"
                rel="noopener noreferrer"
                className="absolute top-3 right-3 z-20"
              >
                <Image
                  src="/about-us/link.png"
                  alt="LinkedIn"
                  width={30}
                  height={30}
                />
              </a>
              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60 rounded-[16px]"></div>
              <div className="absolute bottom-4 left-4 text-white z-10">
                <h3 className="text-[16px] font-semibold">Priya Nair</h3>
                <p className="text-[14px] font-normal">
                  Co-founder & COO Miles SoBA
                </p>
              </div>
            </div> */}

            <div className="relative bg-white lg:w-[210px] md:w-[180px] h-[293px] rounded-[20px] shadow-md overflow-hidden">
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/about-us/Rohini%20Sripada.webp"
                alt="Rohini Sripada"
                className="object-cover w-full h-full rounded-[24px]"
                width={210}
                height={293}
              />
              <a
                href="https://www.linkedin.com/in/rohini-sripada-9312235/"
                target="_blank"
                rel="noopener noreferrer"
                className="absolute top-3 right-3 z-20"
              >
                <Image
                  src="/about-us/link.png"
                  alt="LinkedIn"
                  width={30}
                  height={30}
                />
              </a>
              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60 rounded-[16px]"></div>
              <div className="absolute bottom-4 left-4 text-white z-10">
                <h3 className="text-[16px] font-semibold">Rohini Sripada</h3>
                <p className="text-[14px] font-normal">
                  Chief Business Officer
                </p>
              </div>
            </div>

            <div className="relative bg-white lg:w-[210px] md:w-[180px] h-[293px] rounded-[20px] shadow-md overflow-hidden">
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/about-us/Ravi%20T.webp"
                alt="Ravi T"
                className="object-cover w-full h-full rounded-[24px]"
                width={210}
                height={293}
              />
              <a
                href="https://www.linkedin.com/in/ravi-thiruvengalam-178923171/"
                target="_blank"
                rel="noopener noreferrer"
                className="absolute top-3 right-3 z-20"
              >
                <Image
                  src="/about-us/link.png"
                  alt="LinkedIn"
                  width={30}
                  height={30}
                />
              </a>
              <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-60 rounded-[16px]"></div>
              <div className="absolute bottom-4 left-4 text-white z-10">
                <h3 className="text-[16px] font-semibold">Ravi T</h3>
                <p className="text-[14px] font-normal">Chief Sales Officer</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeamSectionDesktop;
